import z from 'zod/v4';
import { DefaultPresetSchema } from './default-preset-schema';
import type { PresetConfig } from './types';
import { createPresetSchema } from './utils';

export const ListingContractDraftDataSchema = z.object({
  // Attach the accepted co-applicant as tenant 2 on contract drafts created
  // from an apartment listing that allows co-applicants.
  coApplicantAsTenant: z.boolean(),
});

export type ListingContractDraftPresetData = z.infer<
  typeof ListingContractDraftDataSchema
>;

export const DEFAULT_LISTING_CONTRACT_DRAFT_PRESET_DATA: ListingContractDraftPresetData =
  {
    coApplicantAsTenant: true,
  };

export const V1Schema = createPresetSchema('1', ListingContractDraftDataSchema);

export const LISTING_CONTRACT_DRAFT_PRESET_IDENTIFIER = 'listing.contractdraft';
// Single preset, so one fixed key per owner
export const LISTING_CONTRACT_DRAFT_PRESET_KEY = 'default';

const ListingContractDraftPresetSchema = z.object({
  ...DefaultPresetSchema.shape,
  context: z.literal(LISTING_CONTRACT_DRAFT_PRESET_IDENTIFIER),
  data: V1Schema,
});

export const ListingContractDraftPreset = {
  identifier: LISTING_CONTRACT_DRAFT_PRESET_IDENTIFIER,
  currentSchema: ListingContractDraftPresetSchema,
  currentVersion: '1',
  migrations: null,
  single: true,
} as const satisfies PresetConfig;
